module.exports = __webpack_public_path__ + "static/media/UrnofShadows.9373e540.png";